import React, {Suspense} from "react"
import {BrowserRouter, Route, Routes} from "react-router-dom"
import Home from "./views/home"
import Information from "./views/information"
import NotFound from "./views/not-found";
import ProtectedRoute from "./components/ProtectedRoute";
import Unauthenticated from "./views/unauthenticated";
import Loading from "./components/Loading/Loading";


export default function App() {
    return (
        <BrowserRouter>
            <Suspense fallback={<Loading isShowing={true}/>}>
                <Routes>
                    <Route exact path={"/not-found"} element={<NotFound/>}/>
                    <Route exact path={"/error"} element={<Unauthenticated/>}/>
                    <Route
                        path='/'
                        element={<ProtectedRoute component={Home}/>}
                    />
                    <Route
                        path='/information'
                        element={<ProtectedRoute component={Information}/>}
                    />
                </Routes>
            </Suspense>
        </BrowserRouter>
    )
}
